/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Faq_DescInputs */

const en_mk_nav_faq_desc = /** @type {(inputs: Mk_Nav_Faq_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting started, costs, data, and publishing.`)
};

const id_mk_nav_faq_desc = /** @type {(inputs: Mk_Nav_Faq_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara mulai, biaya, data, dan penerbitan.`)
};

/**
* | output |
* | --- |
* | "Getting started, costs, data, and publishing." |
*
* @param {Mk_Nav_Faq_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_faq_desc = /** @type {((inputs?: Mk_Nav_Faq_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Faq_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_faq_desc(inputs)
	return en_mk_nav_faq_desc(inputs)
});